import withQuery from 'with-query';

import { LatestQuote } from '../py-generated/datalouder/price/types';
import { Category } from '../py-generated/datalouder/stock/types';
import {
  Region,
  statisticsHistoryRequestParameters,
  TimeSeries,
} from '../shared/types';
import { apiUrl, apiv2Url } from './config';
import {
  getOption,
  getPromise,
  handleJSONResponse,
  RequestOptions,
} from './utils';

const statisticsv2 = async (
  abortSignal: AbortSignal,
  category: Category,
  dateStr: string
): Promise<any> => {
  const response = await getPromise<any, any>(
    `${apiv2Url}/statistics`,
    { category, date: dateStr },
    undefined,
    abortSignal
  );
  if (response.data_file) {
    response.data = await fetch(response.data_file).then(
      handleJSONResponse<any>()
    );
  }
  return response;
};

const statisticsHistoryOptions = (
  category: Category,
  ticker: string
): RequestOptions => ({
  url: withQuery(`${apiv2Url}/statistics/history`, { category, ticker }),
  ...getOption(),
});

const statisticsHistory = (category: Category) =>
  getPromise<statisticsHistoryRequestParameters, string[]>(
    `${apiv2Url}/statistics/dates`,
    {
      category,
    }
  );
const histograms = (abortSignal: AbortSignal, region: Region): Promise<any> =>
  getPromise<any, any>(
    `${apiUrl}/dailyprice/histograms`,
    { region },
    undefined,
    abortSignal
  );

const bidAskOptions = (stockCode: string): RequestOptions => ({
  url: withQuery(`${apiUrl}/dailyprice/bidask`, { stockCode }),
  ...getOption(),
});

const timeSeries = (
  abortSignal: AbortSignal,
  data: string[],
  unit: TimeSeries.Unit,
  lastDate?: string
) =>
  getPromise<TimeSeries.RequestParameters, any>(
    `${apiv2Url}/timeseries`,
    { data: data.join(','), unit, lastDate },
    undefined,
    abortSignal
  );

const realtimePrice = (stockID: string[]) =>
  getPromise<any, LatestQuote[]>(`${apiv2Url}/latestPrice`, {
    stockID: stockID.join(','),
  });

export default {
  histograms,
  statisticsHistoryOptions,
  bidAskOptions,
  timeSeries,
  realtimePrice,
  statisticsv2,
  statisticsHistory,
};
